module.exports = __webpack_public_path__ + "img/gasIcon.31491f7c.svg";